import React from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { popupOpenClose } from "../../../action/action";








function Event3_ListVenues(props) {
    const { t } = props;
    

   const  doSetInventoryListCorrespondingVenue=(venueId)=>{
    
    props.selectedEvent.events.find(event=>{
        if(event.venueId==venueId){
                props.setInventoryList(event.inventories);
                props.setSelectedInventory(null);
            return true;
        }
        return false;
    })
   }

 

    useEffect(() => {
        scrollToTop()
        

    }, [])

    return (<>
        <header className="inner-pages w-footer subpages">
            <a className="button-back" onClick={props.back}></a>
            <div className="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
            </div>
        </header>
        <section class="widgets spa-listing spa-details">
            <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl && (
                    <div class="widget-header-img">
                        <img
                            src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                            alt={props.currentWidgetObj.displayName}
                        />
                    </div>
                )}
                <div class="widget-header-title">{t(`events.heading3`)}</div>
            </div>

            <div class="widgets">
                <div class="row margin-bottom-2">
                    <div class="row">
                        <div class="col">
                            <div class="detail-body stay-body">
                                {
                                    props.selectedEvent  && props.selectedEvent.events
                                        ?
                                        (
                                            Array.isArray(props.selectedEvent.events) && props.selectedEvent.events.length > 0
                                                ?
                                                <form>
                                                    <div class="form-row">
                                                        <p class="heading">{t(`events.available_venues`)}</p>
                                                        <div class="form-options">
                                                            { props.selectedEvent.events.map((event) => {
                                                                return (
                                                                    <label class="radio-group">
                                                                        <input
                                                                            type="radio"
                                                                            name="Times"
                                                                            value={JSON.stringify({ venueId: event.venueId, venueName: event.venueName })}
                                                                            checked={
                                                                                JSON.stringify(
                                                                                    props.selectedVenue
                                                                                ) == JSON.stringify({ venueId: event.venueId, venueName: event.venueName })
                                                                            }
                                                                            onChange={(e) => {
                                                                                console.log('log e', e)
                                                                                console.log(JSON.parse(e.target.value));
                                                                                props.setSelectedVenue(
                                                                                    JSON.parse(e.target.value)
                                                                                );
                                                                                props.setSelectedInventory(null);
                                                                                doSetInventoryListCorrespondingVenue((JSON.parse(e.target.value)).venueId)
                                                                            }}
                                                                        />
                                                                        {
                                                                            event.venueName
                                                                        }
                                                                    </label>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </form>
                                                :

                                                <div className="no_reservation">
                                                    {t("events.venue_not_available")}
                                                </div>

                                        )

                                        :
                                        <div className="no_reservation">
                                            {t("events.error.error")}
                                        </div>
                                }

                            </div>
                        </div>
                    </div>


                    <div class="widgets">
                        <div class="row margin-bottom-2">
                            <div class="row">
                                <div class="col">
                                   {
                                    props.selectedVenue &&  <div class="detail-body stay-body">
                                        {
                                            props.inventoryList
                                                ?
                                                (
                                                    Array.isArray(props.inventoryList) && props.inventoryList.length > 0
                                                        ?
                                                        <form>
                                                            <div class="form-row">
                                                                <p class="heading">{t(`events.available_sub_event`)}</p>
                                                                <div class="form-options">
                                                                    { props.inventoryList.map((inventory) => {
                                                                        return (
                                                                            <label>
                                                                                <input
                                                                                    type="radio"
                                                                                    name="Times"
                                                                                    value={JSON.stringify(inventory)}
                                                                                    checked={
                                                                                        JSON.stringify(
                                                                                            props.selectedInventory
                                                                                        ) == JSON.stringify(inventory)
                                                                                    }
                                                                                    onChange={(e) => {
                                                                                        console.log('log e', e)
                                                                                        console.log(JSON.parse(e.target.value));
                                                                                        props.setSelectedInventory(
                                                                                            JSON.parse(e.target.value)
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                
                                                                                        <p class="inventory_name">{inventory.inventory_name}</p>
                                                                                        
                                                                                        
                                                                                        <div class="options">
                                                                            
                                                                                            <div class="amount inventory_amount">{`${props.currencyCode} ${inventory.price}`}</div>
                                                                                        </div>
                                                                                
                                                                            </label>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </form>
                                                        :

                                                        <div className="no_reservation">
                                                            {t("events.inventory_not_available")}
                                                        </div>

                                                )
                                                :
                                                <div className="no_reservation">
                                                    {t("events.error.error")}
                                                </div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="form-controls">
                            <button
                                disabled={!props.selectedVenue  || !props.selectedInventory}
                                onClick={
                                    props.next
                                }
                            >
                                {t(`events.continue`)}
                            </button>
                            <button onClick={props.back}>{t(`events.back`)}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    </>

    )
}
const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails
            ? state.store.home.clientConfig.currencyDetails.code
            : ""

    }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Event3_ListVenues));
